(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-nav-drawer"] && !Shopify.designMode) return;
  try {
    
  class MobileNavDrawer extends HTMLElement {
    connectedCallback() {
      this.closers = this.querySelectorAll('[data-mobile-nav-drawer-close]');
      this.closers.forEach((el) => el.addEventListener('click', () => this.close()));

      document.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-mobile-nav-drawer-toggle]');
        if (trigger) {
          event.preventDefault();
          this.open();
        }
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') this.close();
      });
    }

    open() {
      this.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
    }

    close() {
      this.classList.remove('is-open');
      document.documentElement.style.overflow = '';
    }
  }

  customElements.define('mobile-nav-drawer', MobileNavDrawer);

  } catch(e) { console.error(e); }
})();
})();
